import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const shake = keyframes`
    0%, 100% {
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
        transform: translateX(-5px);
    },
    20%,
    40%,
    60%,
    80% {
        transform: translateX(5px);
    },
`;

export const ShakeAnimation = styled(motion.div)<{ readonly isShaking: boolean }>`
    animation: ${({ isShaking }) =>
        isShaking
            ? css`
                  ${shake} 500ms 2
              `
            : 'none'};
    height: 100%;
    width: 100%;
    will-change: transform;
    position: relative;
    z-index: 2;
`;

export const Backdrop = styled(motion.div)`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
`;

export const ContentContainer = styled(motion.div)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${({ theme }) => theme.spacing['4xl']};
`;

export const ContentSections = styled.div`
    background-color: ${({ theme }) => theme.colors.white[200]};
    box-sizing: border-box;
    display: grid;
    grid-template-columns: minmax(0px, 1fr) minmax(0px, 1fr);
    gap: ${({ theme }) => theme.spacing.xl};
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    width: 100%;
    max-width: 100%;
    margin-top: ${({ theme }) => theme.spacing.xxl};
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing['3xl']};
`;

export const SectionHeader = styled.div`
    box-sizing: border-box;
    font-size: ${({ theme }) => theme.typography.body.M.medium.fontSize};
    font-weight: ${({ theme }) => theme.typography.body.M.medium.fontWeight};
    line-height: ${({ theme }) => theme.typography.body.M.medium.lineHeight};
    display: flex;
    flex-direction: row;
    margin-bottom: ${({ theme }) => theme.spacing.l};
    gap: ${({ theme }) => theme.spacing.s};
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    position: relative;
    flex-shrink: 0;
`;

export const SectionContent = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    flex-shrink: 0;
    width: 100%;
    text-align: wrap;
    white-space: break-spaces;
    word-wrap: break-word;
    & > p {
        margin: 0;
    }
    & > ul {
        margin: 0;
        padding-left: 0;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing['3xl']};
`;

export const StyledStickyHeader = styled.div`
    position: sticky;
    top: 0;
    padding-top: ${({ theme }) => theme.spacing.xxl};
    z-index: 1;
    background-color: ${({ theme }) => theme.colors.white[200]};
    padding-bottom: ${({ theme }) => theme.spacing.xxl};
    padding-left: ${({ theme }) => `${theme.spacing.xxl}`};
    margin-left: ${({ theme }) => `-${theme.spacing.xxl}`};
    padding-right: ${({ theme }) => `${theme.spacing.xxl}`};
    margin-right: ${({ theme }) => `-${theme.spacing.xxl}`};
`;

export const FlexRowContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing.xl};
`;

// The old world is wrapping the page with a "white dummy card",
// in the new world we have to remove the background and padding/margins.
export const GrayWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.gray[200]};
    border-radius: 0;
    height: 100%;
`;

export const GrayWrapperInner = styled.div`
    padding-left: ${({ theme }) => theme.spacing.m};
`;
